import { Territory } from "../models";

export const getTerritoryName = (id: number | undefined, territories: Territory[]) => {
    const territory = territories.find((t) => t.id === id);
    return territory?.name ?? "";
};

